
<button matButton [matMenuTriggerFor]="menu" class="menu-btn p-2">
    <i class="fa-solid fa-bars pe-2"></i>Menu
    @if(teamMoodAdminMenu){
        <!-- TeamMood Admin Menu -->
            @for(item of teamMoodAdminMenu; track item){
                @if(item.linkType =='link'){
                        <a class="mx-3 text-white" [routerLink]="item.teamId? [item.stateName, item.teamId]: [item.stateName]" title="{{item.name | translate}}">
                            <i class="{{item.icon}}"></i>&nbsp;{{item.name | translate}}
                        </a>
                }
            }
    }
</button>

<mat-menu #menu="matMenu" yPosition="below" class='customClass'>
    <div>
        @if(sideHeader?.listenMenu){
            <span class="nav-text-tilte">{{$safeNavigationMigration(sideHeader?.listenMenu?.name) | translate}}</span>
            <ul class="side-menu">
                @for(item of sideHeader?.listenMenu?.items; track item){
                    @if(item?.linkType =='link'){
                        <li class="nav-item mx-lg-2">
                            <a mat-menu-item class="nav-link" [routerLink]="item.teamId?[item.stateName,item.teamId]:[item.stateName]"
                               matTooltip="{{item.description |translate}}" matTooltipShowDelay="500" matTooltipPosition="right"
                                routerLinkActive="active">
                                <i class="{{item.icon}}"></i>&nbsp;{{item.name | translate}}
                            </a>
                        </li>
                    }
                }
            </ul>
            }

            @if(sideHeader?.respondMenu){
            <span class="nav-text-tilte">{{$safeNavigationMigration(sideHeader?.respondMenu?.name) | translate}}</span>
            <ul class="side-menu">
                @for(item of sideHeader?.respondMenu?.items; track item){
                    @if(item.linkType =='link'){
                        <li class="nav-item mx-lg-2">
                            <a mat-menu-item class="nav-link" [routerLink]="item.teamId?[item.stateName,item.teamId]:[item.stateName]"
                               matTooltip="{{item.description |translate}}" matTooltipShowDelay="500" matTooltipPosition="right"
                               routerLinkActive="active">
                                @if(item.counter > 0){
                                    <span matBadge="{{item.counter}}" matBadgeOverlap="false" matBadgeSize="small"><i class="{{item.icon}}"></i>&nbsp;{{item.name | translate}}</span>
                                } @else {
                                    <i class="{{item.icon}}"></i>&nbsp;{{item.name | translate}}
                                }
                            </a>
                        </li>
                    }
                }
            </ul>
            }

            @if(sideHeader?.analyseMenu){
            <span class="nav-text-tilte">{{$safeNavigationMigration(sideHeader?.analyseMenu?.name) | translate}}</span>
            <ul class="side-menu">
                @for(item of sideHeader?.analyseMenu?.items; track item){
                    @if(item.linkType =='link'){
                        <li class="nav-item mx-lg-2">
                            <a mat-menu-item class="nav-link" [routerLink]="item.teamId?[item.stateName,item.teamId]:[item.stateName]"
                               matTooltip="{{item.description |translate}}" matTooltipShowDelay="500" matTooltipPosition="right"
                               routerLinkActive="active">
                                <i class="{{item.icon}}"></i>&nbsp;{{item.name | translate}}
                            </a>
                        </li>
                    }
                }
            </ul>
            } 
    </div>

    <div>
        <div>
            @if(sideHeader?.adminMenu){
                <span class="nav-text-tilte">{{$safeNavigationMigration(sideHeader?.adminMenu?.name) | translate}}</span>
                <ul class="side-menu d-flex flex-column">
                    @for(item of sideHeader?.adminMenu?.items; track item){
                        @if(item.linkType =='link'){
                            <li mat-menu-item class="nav-item mx-lg-2">
                                <a class="nav-link mb-1"
                                   matTooltip="{{item.description |translate}}" matTooltipShowDelay="500" matTooltipPosition="right"
                                   [routerLink]="item.teamId?[item.stateName,item.teamId]:[item.stateName]" routerLinkActive="active">
                                    <i class="{{item.icon}}"></i>&nbsp;{{item.name | translate}}
                                </a>
                            </li>
                        }
                    }
                </ul>
                }
        </div>

        <div class="side-menu nav-item mx-lg-2 ps-2">
            <a mat-menu-item  class="nav-link mb-1"
               title="{{'contact_us' | translate}}"
               (click)="openContactUsDialog()"
               matTooltip="{{'contact_us_desc' |translate}}" matTooltipShowDelay="500">
                <i class="far fa-envelope"></i>&nbsp;{{'contact_us' | translate}}
            </a>
        </div>

    </div>
</mat-menu>